export default {
    targetSetDescriptor: {
        defaults: {
            rootProperty: 'descriptors',
            endpoint: 'targetSetV.php'
        },
        read: {
            params: {
                action: 'get',
                property: 'target_descriptors'
            }
        },
        create: {
            params: {
                action: 'create',
                property: 'target_descriptors'
            }
        },
        update: {
            params: {
                action: 'update',
                property: 'target_descriptors'
            }
        },
        destroy: {
            params: {
                action: 'delete',
                property: 'target_descriptors'
            }
        }
    }
}